module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticesPosing-ed4fd2a18932986d429cc02c13295d3c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticesPosing.png
// module id = 2485
// module chunks = 2